import React from 'react';

export const Forum = (props) => (
  <svg height="1em" viewBox="0 0 24 24" width="1em" {...props}>
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path
      className="forum-icon"
      d="M4 4h16v12H5.17L4 17.17V4m0-2c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4zm2 10h8v2H6v-2zm0-3h12v2H6V9zm0-3h12v2H6V6z"
    />
  </svg>
);

export const Slide = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M18.872 18.448H6.128A2.136 2.136 0 014 16.302V7.145C4 5.96 4.952 5 6.128 5h12.744C20.048 5 21 5.96 21 7.145v9.157a2.136 2.136 0 01-2.128 2.146z"
      fill="currentColor"
    />
    <path
      d="M12.413 21c-.241 0-.438-.246-.438-.546v-3.168c0-.3.197-.546.438-.546.242 0 .439.246.439.546v3.168c0 .3-.197.546-.439.546z"
      fill="currentColor"
    />
    <rect x={8} y={12} width={2} height={4} rx={0.25} fill="#fff" />
    <rect x={11.5} y={10} width={2} height={6} rx={0.25} fill="#fff" />
    <rect x={15} y={8} width={2} height={8} rx={0.25} fill="#fff" />
    <path fill="currentColor" d="M3 5h19v2H3z" />
    <circle cx={12.375} cy={21.375} r={0.875} stroke="currentColor" />
  </svg>
);

export const Video = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M18.237 18H6.735A2.739 2.739 0 014 15.252V7.748A2.739 2.739 0 016.735 5H18.24a2.738 2.738 0 012.731 2.748v7.509A2.738 2.738 0 0118.237 18z"
      fill="currentColor"
    />
    <path
      d="M10.964 8.765l4.638 2.343c.172.088.18.333.013.43l-4.613 2.668a.243.243 0 01-.365-.211l-.026-5.01a.242.242 0 01.353-.22z"
      fill="#fff"
    />
  </svg>
);

export const Correct = (props) => (
  <svg width={50} height={50} viewBox="0 0 50 50" fill="none" {...props}>
    <path
      d="M25 49c13.255 0 24-10.745 24-24S38.255 1 25 1 1 11.745 1 25s10.745 24 24 24z"
      stroke="#595959"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M38 16L20.125 33 12 25.273"
      stroke="#00C558"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Incorrect = (props) => (
  <svg width={50} height={50} viewBox="0 0 50 50" fill="none" {...props}>
    <path
      d="M25 49c13.255 0 24-10.745 24-24S38.255 1 25 1 1 11.745 1 25s10.745 24 24 24z"
      stroke="#595959"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M35.75 14.25l-20.5 20.5M15.25 14.25l20.5 20.5"
      stroke="#EB5757"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Achieve = (props) => (
  <svg width={14} height={14} fill="none" viewBox="0 0 14 14" {...props}>
    <path
      d="M3.404 6.495a3.596 3.596 0 107.193 0c0-1.9.083-3.187.174-4.025.073-.68-.478-1.37-1.162-1.37H4.393c-.684 0-1.236.69-1.162 1.37.09.838.173 2.124.173 4.025z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.757 8.342a.5.5 0 000-.707L3.258 6.136a19.966 19.966 0 00-.715-.674c-.2-.182-.378-.344-.533-.499-.346-.346-.479-.565-.501-.73a.617.617 0 01.005-.24h1.99a.5.5 0 000-1H1.512c-.175 0-.472.05-.71.293-.256.259-.344.635-.284 1.08.07.526.434.953.785 1.304.172.172.366.349.56.526l.043.039c.212.193.43.393.645.608L4.05 8.342a.5.5 0 00.707 0zm-3.238-4.36zM9.243 8.342a.5.5 0 010-.707l1.499-1.499c.233-.234.466-.447.678-.64l.037-.034c.2-.182.378-.344.532-.499.347-.346.48-.565.502-.73a.618.618 0 00-.005-.24h-1.99a.5.5 0 010-1h1.992c.175 0 .472.05.71.293.256.259.344.635.284 1.08-.07.526-.434.953-.785 1.304-.172.172-.366.349-.56.526l-.043.039c-.212.193-.43.393-.645.608L9.95 8.342a.5.5 0 01-.707 0zm3.238-4.36z"
      fill="currentColor"
    />
    <rect x={2.805} y={11.101} width={8.392} height={1.798} rx={0.899} fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M7.54 9.1v2.998h-1V9.1h1z" fill="currentColor" />
  </svg>
);

export const ArticleType = (props) => (
  <svg width={14} height={16} viewBox="0 0 14 16" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.492 1.158c.4-.4.942-.625 1.508-.625h5.333A.8.8 0 018.9.768l4 4a.8.8 0 01.234.565v8A2.133 2.133 0 0111 15.467H3a2.133 2.133 0 01-2.133-2.134V2.667c0-.566.224-1.109.625-1.509zM3 2.133a.533.533 0 00-.533.534v10.666a.533.533 0 00.533.534h8a.534.534 0 00.533-.534V5.665L8.002 2.133H3z"
      fill="#A6A6A6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.333.533a.8.8 0 01.8.8v3.2h3.2a.8.8 0 010 1.6h-4a.8.8 0 01-.8-.8v-4a.8.8 0 01.8-.8zM3.533 8.667a.8.8 0 01.8-.8h5.334a.8.8 0 110 1.6H4.333a.8.8 0 01-.8-.8zM3.533 11.333a.8.8 0 01.8-.8h5.334a.8.8 0 110 1.6H4.333a.8.8 0 01-.8-.8zM3.533 6a.8.8 0 01.8-.8h1.334a.8.8 0 010 1.6H4.333a.8.8 0 01-.8-.8z"
      fill="#A6A6A6"
    />
  </svg>
);

export const LiveCodingType = (props) => (
  <svg width={16} height={9} viewBox="0 0 16 9" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.5 1.375A.8.8 0 013.625 2.5l-1.6 2 1.6 2a.8.8 0 01-1.25 1l-2-2.5a.8.8 0 010-1l2-2.5A.8.8 0 013.5 1.375zM12.5 1.375a.8.8 0 00-.125 1.125l1.6 2-1.6 2a.8.8 0 101.25 1l2-2.5a.8.8 0 000-1l-2-2.5a.8.8 0 00-1.125-.125zM10.393.303a.8.8 0 01.304 1.09l-3.945 7a.8.8 0 01-1.394-.786l3.945-7a.8.8 0 011.09-.304z"
      fill="#A6A6A6"
    />
  </svg>
);

export const QuizType = (props) => (
  <svg width={8} height={13} viewBox="0 0 8 13" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.3 1.975A2.287 2.287 0 001.754 3.47a.8.8 0 11-1.51-.53A3.887 3.887 0 017.8 4.234c0 1.453-1.08 2.434-1.9 2.98a8.05 8.05 0 01-1.18.645c-.003 0-.005.002-.008.003V9a.8.8 0 11-1.6 0V7.322a.8.8 0 01.547-.76l.253.76-.253-.76h.002l.018-.006.081-.03a6.454 6.454 0 001.252-.642C5.736 5.402 6.2 4.839 6.2 4.234v-.001a2.287 2.287 0 00-1.9-2.258zm3.5 2.26H7h.8zM3.195 11.438a.8.8 0 01.8-.8h.01a.8.8 0 010 1.6h-.01a.8.8 0 01-.8-.8z"
      fill="#A6A6A6"
    />
  </svg>
);

export const VideoPlayerType = (props) => (
  <svg width={11} height={12} viewBox="0 0 11 12" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.2 2.133A1.467 1.467 0 012.379.851l6.96 3.867a1.467 1.467 0 010 2.564L2.38 11.15A1.467 1.467 0 01.2 9.867V2.133zm1.6.227v7.28L8.353 6 1.8 2.36z"
      fill="#A6A6A6"
    />
  </svg>
);

export const NoteBoardType = (props) => (
  <svg width={14} height={13} viewBox="0 0 14 13" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.5 1.6a.4.4 0 00-.4.4v9c0 .22.18.4.4.4h6.378L11.9 8.378V2a.4.4 0 00-.4-.4h-9zm11 7.44L9.54 13H2.5a2 2 0 01-2-2V2a2 2 0 012-2h9a2 2 0 012 2v7.04z"
      fill="#A6A6A6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.784 7.583a.8.8 0 01-.8.8h-3.1v3.101a.8.8 0 01-1.6 0v-3.9a.8.8 0 01.8-.8h3.9a.8.8 0 01.8.8z"
      fill="#A6A6A6"
    />
  </svg>
);

export const GradedExamType = (props) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.25 10a.75.75 0 01.442-.684l8-3.606a.75.75 0 01.616 0l8 3.606a.75.75 0 010 1.368l-8 3.606a.75.75 0 01-.616 0l-8-3.606A.75.75 0 013.25 10zm2.575 0L12 12.783 18.175 10 12 7.217 5.825 10z"
      fill="#A6A6A6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.407 10.722a.75.75 0 01.343.63v5.236a.75.75 0 01-.546.722l-2.283.645c-1.91.539-3.932.539-5.842 0l-2.283-.645a.75.75 0 01-.546-.722v-5.236a.75.75 0 011.058-.684L12 12.784l4.692-2.115a.75.75 0 01.715.054zm-1.157 1.79l-3.942 1.778a.75.75 0 01-.616 0L7.75 12.513v3.508l1.737.49a9.25 9.25 0 005.027 0l1.736-.49v-3.508zM19.5 12.5V10h1v2.5h-1z"
      fill="#A6A6A6"
    />
    <path d="M21 13a1 1 0 11-2 0 1 1 0 012 0z" fill="#DC8E05" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 14a1 1 0 100-2 1 1 0 000 2z"
      fill="#A6A6A6"
    />
  </svg>
);

export const Loading = (props) => (
  <svg width={32} height={32} viewBox="0 0 57 57" fill="currentColor" color="#000" {...props}>
    <g transform="translate(1 1)" fillRule="evenodd">
      <circle cx={5} cy={50} r={5}>
        <animate
          attributeName="cy"
          begin="0s"
          dur="2.2s"
          values="50;5;50;50"
          calcMode="linear"
          repeatCount="indefinite"
        />
        <animate
          attributeName="cx"
          begin="0s"
          dur="2.2s"
          values="5;27;49;5"
          calcMode="linear"
          repeatCount="indefinite"
        />
      </circle>
      <circle cx={27} cy={5} r={5}>
        <animate
          attributeName="cy"
          begin="0s"
          dur="2.2s"
          from={5}
          to={5}
          values="5;50;50;5"
          calcMode="linear"
          repeatCount="indefinite"
        />
        <animate
          attributeName="cx"
          begin="0s"
          dur="2.2s"
          from={27}
          to={27}
          values="27;49;5;27"
          calcMode="linear"
          repeatCount="indefinite"
        />
      </circle>
      <circle cx={49} cy={50} r={5}>
        <animate
          attributeName="cy"
          begin="0s"
          dur="2.2s"
          values="50;50;5;50"
          calcMode="linear"
          repeatCount="indefinite"
        />
        <animate
          attributeName="cx"
          from={49}
          to={49}
          begin="0s"
          dur="2.2s"
          values="49;5;27;49"
          calcMode="linear"
          repeatCount="indefinite"
        />
      </circle>
    </g>
  </svg>
);

export const Medal = (props) => (
  <svg width={18} height={18} viewBox="0 0 18 18" fill="none" {...props}>
    <g stroke="#FAA919" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 11.25A5.25 5.25 0 109 .75a5.25 5.25 0 000 10.5z" />
      <path d="M6.157 10.417L5.25 17.25 9 15l3.75 2.25-.908-6.84" />
    </g>
  </svg>
);

export const GradedExamTimer = (props) => (
  <svg width={18} height={18} viewBox="0 0 18 18" fill="none" {...props}>
    <g stroke="#FAAA19" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 16.5a7.5 7.5 0 100-15 7.5 7.5 0 000 15z" />
      <path d="M9 4.5V9l3 1.5" />
    </g>
  </svg>
);

export const PDFType = (props) => (
  <svg width={14} height={5} fill="none" {...props}>
    <path
      d="M.594 5a.162.162 0 01-.12-.05.162.162 0 01-.048-.118V.275C.426.223.44.18.468.149a.17.17 0 01.126-.05H2.47c.564 0 1.008.134 1.33.4.322.266.483.653.483 1.162 0 .504-.161.886-.483 1.148-.322.256-.766.385-1.33.385H1.44v1.638a.17.17 0 01-.048.126.187.187 0 01-.126.042H.594zm1.84-2.59c.271 0 .477-.063.617-.19.144-.13.217-.32.217-.566 0-.243-.07-.432-.21-.567C2.922.95 2.715.884 2.435.884H1.427V2.41h1.008zM5.415 5a.162.162 0 01-.12-.05.162.162 0 01-.048-.118V.275c0-.052.014-.094.042-.126a.17.17 0 01.126-.05h1.708C8.5.1 9.202.735 9.23 2.005c.01.27.014.452.014.546 0 .088-.005.268-.014.539-.019.653-.196 1.136-.532 1.449-.331.308-.845.462-1.54.462H5.415zm1.708-.812c.387 0 .667-.087.84-.26.173-.172.264-.46.273-.86.01-.28.014-.455.014-.525 0-.075-.005-.248-.014-.518-.01-.383-.105-.663-.287-.84-.182-.182-.47-.273-.861-.273h-.854v3.276h.889zM10.537 5a.162.162 0 01-.12-.05.162.162 0 01-.048-.118V.275c0-.052.014-.094.042-.126a.17.17 0 01.126-.05h3.045a.17.17 0 01.126.05.17.17 0 01.049.126v.504a.162.162 0 01-.05.119.17.17 0 01-.125.049h-2.24v1.316h2.1a.17.17 0 01.126.049c.032.032.049.072.049.119v.504a.162.162 0 01-.05.119.17.17 0 01-.125.049h-2.1v1.729a.162.162 0 01-.05.119.17.17 0 01-.125.049h-.63z"
      fill="#A6A6A6"
    />
  </svg>
);

export const AssignmentIcon = (props) => (
  <svg width={22} height={22} fill="none" {...props}>
    <path
      fill="currentColor"
      d="M 14.2 6.8 v 9.2 c 0 1.768 -1.432 3.2 -3.2 3.2 s -3.2 -1.432 -3.2 -3.2 V 6 a 2 2 90 0 1 4 0 v 8.4 c 0 0.44 -0.36 0.8 -0.8 0.8 s -0.8 -0.36 -0.8 -0.8 V 6.8 H 9 v 7.6 a 2 2 90 0 0 4 0 V 6 c 0 -1.768 -1.432 -3.2 -3.2 -3.2 S 6.6 4.232 6.6 6 v 10 c 0 2.432 1.968 4.4 4.4 4.4 s 4.4 -1.968 4.4 -4.4 V 6.8 h -1.2 z"
    />
  </svg>
);
export const Email = (props) => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_13270_263554)">
      <g clipPath="url(#clip1_13270_263554)">
        <g filter="url(#filter0_ii_13270_263554)">
          <path
            d="M26.5625 35.8974C26.5625 33.3307 29.8854 31.25 33.9844 31.25H78.5156C82.6146 31.25 85.9375 33.3307 85.9375 35.8974V71.9151C85.9375 74.4818 82.6146 76.5625 78.5156 76.5625H33.9844C29.8854 76.5625 26.5625 74.4818 26.5625 71.9151V35.8974Z"
            fill="url(#paint0_linear_13270_263554)"
          />
        </g>
        <g filter="url(#filter1_b_13270_263554)">
          <g opacity="0.7" filter="url(#filter2_ii_13270_263554)">
            <path
              d="M32.8125 29.3269C32.8125 26.9372 36.1354 25 40.2344 25H84.7656C88.8646 25 92.1875 26.9372 92.1875 29.3269V62.8606C92.1875 65.2503 88.8646 67.1875 84.7656 67.1875H40.2344C36.1354 67.1875 32.8125 65.2503 32.8125 62.8606V29.3269Z"
              fill="#F2F2F2"
            />
          </g>
        </g>
        <path
          d="M22.261 64.7568H-1.5625"
          stroke="#595959"
          strokeWidth="0.803105"
          strokeLinecap="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.51318 57.2339C7.51318 56.8874 7.79409 56.6064 8.14061 56.6064H17.5446C17.8911 56.6064 18.1721 56.8874 18.1721 57.2339C18.1721 57.5804 17.8911 57.8613 17.5446 57.8613H8.14061C7.79409 57.8613 7.51318 57.5804 7.51318 57.2339Z"
          fill="#595959"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.1104 42.188C14.1104 41.8415 14.3913 41.5605 14.7378 41.5605H19.7533C20.0998 41.5605 20.3807 41.8415 20.3807 42.188C20.3807 42.5345 20.0998 42.8154 19.7533 42.8154H14.7378C14.3913 42.8154 14.1104 42.5345 14.1104 42.188Z"
          fill="#595959"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.08008 49.7104C4.08008 49.3639 4.36099 49.083 4.7075 49.083H9.72298C10.0695 49.083 10.3504 49.3639 10.3504 49.7104C10.3504 50.057 10.0695 50.3379 9.72298 50.3379H4.7075C4.36099 50.3379 4.08008 50.057 4.08008 49.7104Z"
          fill="#595959"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.8569 49.7104C12.8569 49.3639 13.1378 49.083 13.4844 49.083H14.7382C15.0847 49.083 15.3657 49.3639 15.3657 49.7104C15.3657 50.057 15.0847 50.3379 14.7382 50.3379H13.4844C13.1378 50.3379 12.8569 50.057 12.8569 49.7104Z"
          fill="#595959"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M36.985 30.896C37.1806 30.6115 37.5697 30.5395 37.8541 30.735L58.5295 44.9493C60.9357 46.6036 64.1036 46.6377 66.5448 45.0356L87.1571 31.5088C87.4457 31.3194 87.8332 31.3998 88.0226 31.6884C88.212 31.977 88.1315 32.3645 87.843 32.5538L67.2307 46.0807C64.3648 47.9614 60.646 47.9213 57.8213 45.9794L37.146 31.7651C36.8615 31.5695 36.7895 31.1804 36.985 30.896Z"
          fill="#595959"
        />
      </g>
      <g opacity="0.8" filter="url(#filter3_ii_13270_263554)">
        <path
          d="M83.3394 49.8125C84.4941 47.8125 87.3809 47.8125 88.5356 49.8125L98.2242 66.5938C99.3789 68.5938 97.9356 71.0938 95.6262 71.0938H76.2488C73.9394 71.0938 72.4961 68.5938 73.6508 66.5938L83.3394 49.8125Z"
          fill="#F2F2F2"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M85.9373 55.2627C86.4369 55.2627 86.8419 55.6677 86.8419 56.1673V63.2808C86.8419 63.7804 86.4369 64.1854 85.9373 64.1854C85.4377 64.1854 85.0327 63.7804 85.0327 63.2808V56.1673C85.0327 55.6677 85.4377 55.2627 85.9373 55.2627Z"
        fill="#595959"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M85.9373 66.1182C86.4369 66.1182 86.8419 66.5232 86.8419 67.0228V67.9274C86.8419 68.427 86.4369 68.832 85.9373 68.832C85.4377 68.832 85.0327 68.427 85.0327 67.9274V67.0228C85.0327 66.5232 85.4377 66.1182 85.9373 66.1182Z"
        fill="#595959"
      />
    </g>
    <defs>
      <filter
        id="filter0_ii_13270_263554"
        x="26.5625"
        y="31.25"
        width="59.375"
        height="45.3125"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-2" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0" />
        <feBlend mode="overlay" in2="shape" result="effect1_innerShadow_13270_263554" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          mode="normal"
          in2="effect1_innerShadow_13270_263554"
          result="effect2_innerShadow_13270_263554"
        />
      </filter>
      <filter
        id="filter1_b_13270_263554"
        x="22.8125"
        y="15"
        width="79.375"
        height="62.1875"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation="5" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_13270_263554" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_13270_263554"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_ii_13270_263554"
        x="32.8125"
        y="25"
        width="59.375"
        height="42.1875"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-2" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0" />
        <feBlend mode="overlay" in2="shape" result="effect1_innerShadow_13270_263554" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          mode="normal"
          in2="effect1_innerShadow_13270_263554"
          result="effect2_innerShadow_13270_263554"
        />
      </filter>
      <filter
        id="filter3_ii_13270_263554"
        x="73.2441"
        y="48.3125"
        width="25.3867"
        height="22.7812"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-2.31579" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0" />
        <feBlend mode="overlay" in2="shape" result="effect1_innerShadow_13270_263554" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2.31579" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          mode="normal"
          in2="effect1_innerShadow_13270_263554"
          result="effect2_innerShadow_13270_263554"
        />
      </filter>
      <linearGradient
        id="paint0_linear_13270_263554"
        x1="85.9375"
        y1="50.4323"
        x2="26.5625"
        y2="50.4323"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EE6622" />
        <stop offset="1" stopColor="#FAA919" />
      </linearGradient>
      <clipPath id="clip0_13270_263554">
        <path
          d="M0 8C0 3.58172 3.58172 0 8 0H92C96.4183 0 100 3.58172 100 8V92C100 96.4183 96.4183 100 92 100H8C3.58172 100 0 96.4183 0 92V8Z"
          fill="white"
        />
      </clipPath>
      <clipPath id="clip1_13270_263554">
        <rect width="100" height="100" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
